import { ResponseToken } from "src/app/redux/effects/session.effect";

/**
 * Elimina todas las cookies disponibles en el dominio actual.
 */
export function deleteAllCookies(): void {
  document.cookie
    .split(';')
    .map(cookie => cookie.trim())
    .forEach(cookie => {
      const eqPos = cookie.indexOf('=');
      const name = eqPos > -1 ? cookie.substring(0, eqPos) : cookie;
      document.cookie = `${name}=; Max-Age=0; path=/;`;
    });
}

/**
 * Dado una estructura de tokens, setea los valores en las cookies.
 * 
 * @param tokens Estructura de tokens
 * @returns 
 */
export function setInCookies(tokens:ResponseToken){
    document.cookie = `access_token=${tokens.accessToken}; max-age=50400; path=/`;
    document.cookie = `refresh_token=${tokens.refreshToken}; max-age=50400; path=/`;
}